import React, { useEffect, useState } from 'react';
import { Box } from '@heycater/design-system';

import { searchCaterers } from 'lib/algolia/client';
import TopCaterers from 'static_pages/marketing_pages/components/TopCaterers';

export default function MPPreviewCards({ ids = [], ctaTitle, ctaLink, title }) {
  const [caterers, setCaterers] = useState([]);

  useEffect(() => {
    async function fetchCaterers() {
      const filters = [];
      if (ids.length > 0) {
        filters.push(`(${ids.map((id) => `slug:"${id}"`).join(' OR ')})`);
      }

      const hits = await searchCaterers('', {
        filters: filters.toString(),
        hitsPerPage: 100,
      });
      setCaterers(hits);
    }
    fetchCaterers();
  }, [ids]);

  return (
    <Box>
      <TopCaterers
        cta={ctaTitle}
        topCaterers={caterers}
        title={title}
        ctaLink={ctaLink}
      />
    </Box>
  );
}
